import { useEffect, useState } from "react";
import { Plane, Building2, FileCheck, Palmtree, Briefcase, Heart, Users, PenLine, ShieldCheck, Banknote, Car, ArrowRight } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import api from "@/lib/api";
import { waLink } from "@/lib/site";

const ICONS = [Plane, Building2, FileCheck, Palmtree, Briefcase, Heart, Users, PenLine, ShieldCheck, Banknote, Car];

export default function Services() {
  const [services, setServices] = useState([]);
  useEffect(() => { api.get("/services").then((r) => setServices(r.data)).catch(() => {}); }, []);

  return (
    <div className="pt-32 pb-24" data-testid="services-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <SectionHeading overline="What We Do" title={<>Every detail, <span className="font-light italic">handled.</span></>} className="mb-4" />
        <Reveal delay={0.1}>
          <p className="text-ink/60 max-w-2xl mb-16">From the first flight search to the cab home — one team, one WhatsApp thread, zero stress. Pick a service or let us bundle them all.</p>
        </Reveal>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="services-grid">
          {services.map((s, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <Reveal key={s.name} delay={(i % 3) * 0.08}>
                <div className="group bg-white border border-border rounded-2xl p-8 h-full hover:border-sun hover:-translate-y-1 transition-all duration-300" data-testid={`service-${s.name.toLowerCase().replace(/[\s&]+/g, "-")}`}>
                  <div className="w-12 h-12 rounded-xl bg-sand/70 flex items-center justify-center mb-5 group-hover:bg-sun transition-colors duration-300">
                    <Icon size={22} className="text-ocean group-hover:text-bone transition-colors duration-300" />
                  </div>
                  <h3 className="font-display text-xl font-bold mb-2">{s.name}</h3>
                  <p className="text-ink/60 text-sm leading-relaxed mb-5">{s.desc}</p>
                  <a href={waLink(`Hi click2trip! I need help with: ${s.name}`)} target="_blank" rel="noreferrer"
                    data-testid={`service-enquire-${i}`}
                    className="inline-flex items-center gap-1.5 text-sm font-semibold text-sun">
                    Enquire <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                  </a>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </div>
  );
}
